import * as React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useLocale } from "@/contexts/LocaleContext";
import { MARKETS, MarketId } from "@/lib/markets";

interface Props {
  open: boolean;
  /** السوق الجديد الذي سيتمّ التحويل إليه. */
  to: MarketId | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * حوار تأكيد قبل تفعيل override سوق المستلم في تدفّق الهديّة.
 * نستعمله لتجنّب مفاجأة العميل بتغيير السعر دون إذن صريح،
 * ولتوضيح أنّ التحويل مرتبط بسوق المستلم لا تحويل عملة.
 */
export function MarketSwitchConfirmDialog({ open, to, onConfirm, onCancel }: Props) {
  const { t, locale } = useLocale();
  const decided = React.useRef(false);
  React.useEffect(() => {
    decided.current = false;
  }, [open, to]);
  if (!to) return null;
  const market = MARKETS[to];
  const country = `${market.flag} ${market.labels[locale]}`;
  return (
    <AlertDialog open={open} onOpenChange={(nextOpen) => {
      // Radix closes after an Action too. A confirmed choice is not a cancel.
      if (!nextOpen && !decided.current) {
        decided.current = true;
        onCancel();
      }
    }}>
      <AlertDialogContent className="z-[70]">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("gift.market_switch_title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("gift.market_switch_body", {
              country,
              currency: market.currency,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t("gift.market_switch_cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => {
            if (decided.current) return;
            decided.current = true;
            onConfirm();
          }}>
            {t("gift.market_switch_continue")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
